import { atom, PrimitiveAtom, useAtom } from "jotai";
import { useEffect } from "react";
import { useCookieConsent } from "~context/cookieConsentContext";
import { pageviewFBWithConsent } from "~features/tracking/consentAwareTracking";

declare interface DataLayerWindow extends Window {
  fbq: any;
  GA_INITIALIZED?: boolean;
}
declare const window: DataLayerWindow;

export const pixelIdAtom = atom<string | undefined>(undefined) as PrimitiveAtom<
  string | undefined
>;

export const ENABLE_TRACKING_SCRIPTS =
  process.env.NODE_ENV === "production" && typeof window !== "undefined";

export const useFacebookPixelScript = (pixelId: string) => {
  const { isMarketingAllowed } = useCookieConsent();
  const [, setPixelId] = useAtom(pixelIdAtom);

  useEffect(() => {
    if (pixelId) {
      setPixelId(pixelId);
    }
  }, [pixelId, setPixelId]);

  useEffect(() => {
    if (pixelId && ENABLE_TRACKING_SCRIPTS && isMarketingAllowed()) {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function (...args: any[]) {
          n.callMethod ? n.callMethod(...args) : n.queue.push(args);
        };
        if (!(f as any)._fbq) (f as any)._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e) as any;
        t.async = true;
        t.defer = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );
      // disable autoConfig events like MicroData or SubscribedButtonClick
      // since they will only be sent to the first loaded pixel(organisation pixel).
      window.fbq("set", "autoConfig", false, pixelId);
      window.fbq("init", pixelId);
      // disable implicit PageView since they will be sent to all the pixels.
      window.fbq.disablePushState = true;

      // Use the consent-aware version for initial pageview
      pageviewFBWithConsent(pixelId);
    }
  }, [pixelId, isMarketingAllowed]);
};
